<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<br/><p style="text-indent:00em">To my husband, Daniel—Thank you for all your love and patience throughout this journey. You are my rock.</p>
<br/><p style="text-indent:00em">To my daughters, Sydney and Emily—You are the reason I was born. I love you both madly.</p>
<br/><p style="text-indent:00em">To my parents—I wish, with all my heart, you could be here for this. You always encouraged me to be more than expected. To climb higher, jump further, and always lend a hand back to help the next person. I hope I’ve made you proud.</p>
<br/><p style="text-indent:00em">To David—you know who you are—Thank you for all the years of learning and experience. When I write, you are always right there with me.</p>
<br/><p style="text-indent:00em">To Debi Culbertson—You’ve been there for me long before the first pages were ever written. Thank you for your years of friendship and encouragement. It means the world.</p>
<br/><p style="text-indent:00em">To Phyllis Ayers, Sandy Shelton, and Julie Campbell—Thank you for taking the time to read through the early drafts and provide ‘invaluable’ feedback. I am forever grateful.</p>
<br/><p style="text-indent:00em">To Jessica Bosak, Brad Henderson, and the rest of the gang at Austin Macauley—Thank you for everything.</p>
<br/><p style="text-indent:00em">And, to all those who have encouraged me to write—Thank you from the bottom of my heart.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?3e912fbd